import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { TeamMembersAddPayload } from 'Interfaces/Team';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: TeamMembersAddPayload) =>
    $actions.team.addTeamMembers(dispatch, values),
  );
};
